import { frontendURL } from '../../../helper/URLHelper';

import SettingsWrapper from '../settings/SettingsWrapper.vue';
import UsuariosIndex from './UsuariosIndex.vue';
import NovoUsuarioIndex from './NovoUsuarioIndex.vue';
import EquipesIndex from './EquipesIndex.vue';
import ModelosMensagensIndex from './ModelosMensagensIndex.vue';
import IntegracoesIndex from './IntegracoesIndex.vue';
import PerfilIndex from './PerfilIndex.vue';
import SocialChannelsIndex from '../settings/socialChannels/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/configuracoes'),
      alias: [frontendURL('accounts/:accountId/configuracao')],
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'configuracoes_perfil',
            params: to.params,
          }),
        },
        {
          path: 'usuarios',
          name: 'configuracoes_usuarios',
          component: UsuariosIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'novo-usuario',
          name: 'configuracoes_novo_usuario',
          component: NovoUsuarioIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'equipes',
          name: 'configuracoes_equipes',
          component: EquipesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'ai-rodizios',
          name: 'configuracoes_ai_rodizios_legacy',
          redirect: to => ({
            name: 'configuracoes_equipes',
            params: to.params,
          }),
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'modelos-mensagens',
          name: 'configuracoes_modelos_mensagens',
          component: ModelosMensagensIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'integracoes',
          name: 'configuracoes_integracoes',
          component: IntegracoesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'canais-sociais',
          name: 'social_channels_settings',
          component: SocialChannelsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'perfil',
          name: 'configuracoes_perfil',
          component: PerfilIndex,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
      ],
    },
  ],
};
